import React from 'react';
import {
    Plus, Minus, Trash2, Clipboard, Download, X, Wand2, Library, FileCheck, Users, User, Menu, UserPlus, ArrowLeft, Pencil, FileText, FileSearch, ClipboardList, ChevronDown, ChevronUp, BarChart2, Dice5, Coins, RefreshCw, ClipboardCheck, Wrench, Briefcase, Monitor, BadgeCheck, Clock, Maximize, Minimize, Timer, Volume2, VolumeX, Activity, Trophy, Eye, CheckCircle, MessageCircle, BookOpen, Puzzle, Grid, Table, Calculator, Play, LogOut, Check, ChevronRight, ChevronLeft, Calendar, Book, DoorOpen, DollarSign, HelpCircle, Moon, Sun, Folder, ClipboardEdit, Crown, Sparkles, UploadCloud, Image, File, Save, ArrowRight, Pause, Square, Settings, AlertCircle, ArrowUp, MoreVertical, LayoutGrid, Copy, Link, TrendingUp, Search, Hash, History, TriangleAlert, ShieldCheck, Shuffle, Armchair, School, GraduationCap
} from 'lucide-react';

export const PlusIcon = Plus;
export const MinusIcon = Minus;
export const TrashIcon = Trash2;
export const ClipboardIcon = Clipboard;
export const DownloadIcon = Download;
export const CloseIcon = X;
export const GenerateIcon = Wand2;
export const MagicIcon = Wand2;
export const LibraryIcon = Library;
export const AssessmentsIcon = FileCheck;
export const ClassesIcon = Users;
export const UserIcon = User;
export const MenuIcon = Menu;
export const UserAddIcon = UserPlus;
export const ClipboardListIcon = ClipboardList;
export const BackArrowIcon = ArrowLeft;
export const EditIcon = Pencil;
export const NoteIcon = FileText;
export const ViewNotesIcon = FileSearch;
export const FolderIcon = Folder;
export const ChevronDownIcon = ChevronDown;
export const ChevronUpIcon = ChevronUp;
export const ChartBarIcon = BarChart2;
export const DiceIcon = Dice5;
export const CoinIcon = Coins;
export const RefreshIcon = RefreshCw;
export const GroupsIcon = Users; // Reuse Users or Group
export const ClipboardCheckIcon = ClipboardCheck;
export const WrenchIcon = Wrench;
export const BriefcaseIcon = Briefcase;
export const DeskIcon = Armchair;
export const ChairIcon = Armchair;
export const DesktopIcon = Monitor;
export const SchoolIcon = School;
export const GraduationCapIcon = GraduationCap;
export const CheckBadgeIcon = BadgeCheck;
export const ClockIcon = Clock;
export const FullscreenIcon = Maximize;
export const ExitFullscreenIcon = Minimize;
export const TimerIcon = Timer;
export const SoundOnIcon = Volume2;
export const SoundOffIcon = VolumeX;
export const SoundWaveIcon = Activity;
export const TrophyIcon = Trophy;
export const EyeIcon = Eye;
export const CheckCircleIcon = CheckCircle;
export const ChatBubbleIcon = MessageCircle;
export const BookOpenIcon = BookOpen;
export const PencilIcon = Pencil;
export const PuzzleIcon = Puzzle;
export const GridIcon = Grid;
export const TableIcon = Table;
export const CalculatorIcon = Calculator;
export const PlayIcon = Play;
export const UsersIcon = Users;
export const LogoutIcon = LogOut;
export const CheckIcon = Check;
export const ChevronRightIcon = ChevronRight;
export const ChevronLeftIcon = ChevronLeft;
export const FileTextIcon = FileText;
export const CalendarIcon = Calendar;
export const BookIcon = Book;
export const DoorIcon = DoorOpen;
export const CurrencyDollarIcon = DollarSign;
export const QuestionMarkCircleIcon = HelpCircle;
export const HelpCircleIcon = HelpCircle;
export const CrownIcon = Crown;
export const SaveIcon = Save;
export const ArrowRightIcon = ArrowRight;
export const ArrowLeftIcon = ArrowLeft;
export const PauseIcon = Pause;
export const StopIcon = Square;
export const CogIcon = Settings;
export const VolumeUpIcon = Volume2;
export const ExpandIcon = Maximize;
export const MinimizeIcon = Minimize;
export const AlertCircleIcon = AlertCircle;
export const ArrowUpIcon = ArrowUp;
export const MoreVerticalIcon = MoreVertical;
export const LayoutGridIcon = LayoutGrid;
export const CopyIcon = Copy;
export const LinkIcon = Link;
export const TrendingUpIcon = TrendingUp;
export const SearchIcon = Search;
export const HashIcon = Hash;
export const HistoryIcon = History;
export const AlertTriangleIcon = TriangleAlert;
export const ShieldCheckIcon = ShieldCheck;
export const ShuffleIcon = Shuffle;
export const UploadCloudIcon = UploadCloud;


// Custom Icons (Keep Original)
export const LogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
        {/* Apple Body */}
        <path d="M17.7 5.3c-1.3-.8-3.1-.4-4.2.3-.6.4-1.2.4-1.8 0-1.1-.7-2.9-1.1-4.2.3-2.1 1.3-3.2 5.5-1.1 9.4 1 1.9 2.7 3.9 4.3 3.9.7 0 1.2-.2 1.8-.5.7-.3 1.5-.3 2.2 0 .6.3 1.1.5 1.8.5 1.6 0 3.3-2 4.3-3.9 2.1-3.9 1-8.1-1.1-9.4z" className="text-red-500" fill="#EF4444" />
        {/* Leaf */}
        <path d="M12.9 2.1c.5-.9 1.7-1.1 2.6-.6.9.5 1.1 1.7.6 2.6-.5.9-1.7 1.1-2.6.6-.9-.5-1.1-1.7-.6-2.6z" className="text-green-500" fill="#10B981" />
        {/* Spectacles Frame - Left Lens */}
        <circle cx="9" cy="11.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-800 dark:text-gray-200" />
        {/* Spectacles Frame - Right Lens */}
        <circle cx="15" cy="11.5" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-800 dark:text-gray-200" />
        {/* Bridge */}
        <path d="M11.5 11.5h1" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" className="text-gray-800 dark:text-gray-200" />
    </svg>
);

export const MicrosoftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path fill="#f35325" d="M1 1h10v10H1z" />
        <path fill="#81bc06" d="M12 1h10v10H12z" />
        <path fill="#05a6f0" d="M1 12h10v10H1z" />
        <path fill="#ffba08" d="M12 12h10v10H12z" />
    </svg>

);

export const MoonIcon = Moon;
export const SunIcon = Sun;
export const SparklesIcon = Sparkles;
export const UploadIcon = UploadCloud;
export const XIcon = X;
export const DocumentIcon = File;
export const ImageIcon = Image;
